import { AuthRepository } from '../data/auth-repository';

/**
 * LogoutUseCase - Business Logic for User Logout
 */
export class LogoutUseCase {
  constructor(private readonly authRepository: AuthRepository) {}

  async execute(): Promise<void> {
    // Clear all stored tokens
    await this.authRepository.clearTokens();
  }
}
